import { fetchExperiment } from '../services';
import { getExperiment } from './selectors';
import { types } from './types';
export const requestExperiment = (projectId) => ({
    type: types.REQUEST_EXPERIMENT,
    payload: { projectId },
});
export const skipExperiment = (projectId) => ({
    type: types.SKIP_EXPERIMENT,
    payload: { projectId },
});
export const setExperiments = (experiments) => ({
    type: types.SET_EXPERIMENTS,
    payload: { experiments },
});
export const fetchExperimentRequest = (projectId) => ({
    type: types.FETCH_EXPERIMENT.REQUEST,
    payload: { projectId },
});
export const fetchExperimentSuccess = ({ projectId, experiment }) => ({
    type: types.FETCH_EXPERIMENT.SUCCESS,
    payload: {
        projectId,
        ...experiment,
    },
});
export const fetchExperimentError = (projectId, error, experimentId) => ({
    type: types.FETCH_EXPERIMENT.ERROR,
    payload: { projectId, experimentId, error },
});
export const createFetchExperiment = (endpoint) => (projectId) => async (dispatch, getState) => {
    // If we have experiment already, we don't want to fetch.
    if (getExperiment(getState(), projectId)) {
        return;
    }
    dispatch(fetchExperimentRequest(projectId));
    try {
        const result = await fetchExperiment(endpoint)(projectId);
        if (result.error) {
            dispatch(fetchExperimentError(projectId, result.error, result.experimentId));
            return;
        }
        dispatch(fetchExperimentSuccess({
            projectId,
            experiment: result,
        }));
    }
    catch (e) {
        dispatch(fetchExperimentError(projectId, 'TECHNICAL_ERROR'));
    }
};
//# sourceMappingURL=actions.js.map